import {Button} from 'antd'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {useLocation} from 'react-router-dom'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../envs/_current/history";
import classNames from "classnames";
import WorkspaceContext from "../WorkspaceContext";
import {WorkspaceOrgDeptContainerContext} from "./WorkspaceOrgDeptContainer";
import {organization_getDepartments_Api} from "../../../apis";
import {EntityPaginationMeta} from "../../AppLocals/EntityList";
import {SectionTemplate} from "../Workspace";
import {useOrganizationDepartmentForm} from "../../AppLocals/Organization/functions/useOrganizationDepartmentForm";
import {DepartmentActionTypes} from "../Host/WorkspaceMembers";
import {DoubleValueItem, ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";
import {FaUsers} from "react-icons/fa6";
import {PiUserCircleCheckFill} from "react-icons/pi";

export const DepartmentCodes = [
    {
        value: 'LEADERSHIP',
        label: 'leadership',
    },
]

const renderGridMeta = (props) => (
    <LayoutContext.Consumer>
        {({isLg}) => (
            <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                <EntityPaginationMeta
                    {...props}
                    style={{position: 'inherit'}}
                />
            </div>
        )}
    </LayoutContext.Consumer>
)

const WorkspaceOrganizationDepartmentList = ({
                                                 filter_actions = {
                                                     sortBy: 'sort-by',
                                                     keyword: 'keyword',
                                                 },
                                             }) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);
    const owner_id = organization?.id;
    const owner_type = 'organization';
    const [refreshKey, setRefreshKey] = useState()
    const {
        current_department_id, setCurrentDepartmentId,
        onSelectWorkspaceOrgDeptContainerRoute
    } = useContext(WorkspaceOrgDeptContainerContext)
    const sortBy = useRouteSearchParam(filter_actions.sortBy)


    const {
        modal,
        handleAction,
        onCancel,
        refreshToken
    } = useOrganizationDepartmentForm({
        organization
    })

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [

                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: DepartmentActionTypes.DEPT_UPDATE,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: DepartmentActionTypes.DEPT_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            refreshToken,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, refreshToken, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({})
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderDepartment({
                t,
                onSelectWorkspaceOrgDeptContainerRoute,
                renderContextMenu
            }),
            PaginationMeta: renderGridMeta,
            apiInfo: organization_getDepartments_Api,
            query: bindQueryParams([{id: owner_id}]),

            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
        renderHeader: ([searchBar, filterBar]) => (
            <div className="flex flex-col gap-4">
                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('list of group / ministry')}
                </h3>
                {searchBar}
                {filterBar}
            </div>
        ),
    })


    return (
        <div className="flex flex-1 flex-col space-y-3">

            <SectionTemplate
                title={t("group management")}
                description={t("manage groups and ministries in your organization.")}
                actionText={t("create group / ministry")}
                renderActionButton={() => (
                    <Button
                        type="primary"
                        className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"
                        onClick={() => {
                            handleAction(DepartmentActionTypes.DEPT_CREATE)
                        }}>
                        + {t('create group / ministry')}
                    </Button>
                )}
            />

            {pager_widget}

            {modal}
        </div>
    )
}


const renderDepartment = ({onSelectWorkspaceOrgDeptContainerRoute, t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {

    return (
        <div
            key={item.id}
            className="p-3 border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
            <div className="mb-2 pb-2 border-b flex items-center gap-3">
                <FaUsers size={20} className="text-indigo-400"/>
                <div className="flex flex-col flex-1">
                    <h2
                        onClick={() => {
                            onSelectWorkspaceOrgDeptContainerRoute({current_department_id: item.id})
                        }}
                        className="font-bold text-lg text-color-000 hover:text-primary leading-snug cursor-pointer">
                        {item.title}
                        {!!item?.active_as_member?.id && <PiUserCircleCheckFill className="ml-3 text-green-300"/>}
                    </h2>
                    <div className="text-xs font-bold text-indigo-400 italic leading-snug tracking-wider">
                        {`${item.group_nbr} - ${item.department_group_title || t("unknown")}`}
                    </div>
                </div>
            </div>
            <ItemInformation
                showIcon={true}
                value={`${item?.member_count} ${t('members')}`}
                className="text-xs"
            />
            {item?.patron_saint_name && (
                <DoubleValueItem
                    showIcon={true}
                    labelFirst="patron saint"
                    valueFirst={item?.patron_saint_name}
                    labelSecond={item?.patron_saint_feast_day ? ' - ' : ''}
                    valueSecond={`(${item?.patron_saint_feast_day})`}
                    className="text-xs"
                />
            )}
            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}


export default WorkspaceOrganizationDepartmentList
